import { AccountObjectFacade } from "../account-object/account-object.facade";
import { ReportApiFacade } from "./report.api-facade";
import { ReportStoreFacade } from "./report.store-facade";
import { Report } from "./report.model";

export class ReportFacade extends AccountObjectFacade<Report, ReportApiFacade, ReportStoreFacade> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/report/report.facade.ts